import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import $ from "jquery";
import DateRangeFilter from '../filters/DateRangeFilter.jsx';
import * as moment from "moment";
import ModalD from "react-awesome-modal";
import { reactSelectStyles,isApiResponse, date_range_config } from '../helpers/utils.js';
import {connect}  from  "react-redux";
var date_config = date_range_config('7', '0', '2020-02-01','0');
const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
var download_count = 0;
class DownloadQueue extends Component{
    constructor(props) {
        super(props);
        this.state = {
            _notificationSystem: null,
            loading:false,
            isSubmit:false,
            download_queue_data:[],
            datefrom:date_config.start_date,
            dateTo:date_config.end_date,
            datefromShow:date_config.display_start_date,
            dateToShow:date_config.display_end_date,
            yestSend:date_config.start_date_value,
            todSend:date_config.end_date_value,
            dateFromLimit: date_config.start_date_limit,
            dateLimit:date_config.end_date_limit,
            user_list:[],
            userValue:[],
            user_id:[],
            dw_msg: "Downloading",
            download_count:1,
            total_count:'',
            model_visible : false,
            userSubGroupName:''
        };

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentWillMount() {
        this.props.currentMenu("unipaynext");
    }
    componentDidMount() {
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        ;
        this.setState({
            user_id:[decoded._id],
            userSubGroupName: decoded.userSubGroupName,
            userValue: [{value:decoded._id, label:decoded.email}],
            object_type: decoded.object_type,
            userType: decoded.userType,
        });
        this.get_all_internal_users();
        this.get_all_lists(this.state.yestSend, this.state.todSend,[decoded._id]);
        this.interval = setInterval(() => this.get_all_lists(this.state.yestSend, this.state.todSend, this.state.user_id), 60000);
    }
    componentWillUnmount() {
        clearInterval(this.interval);
    }

    get_all_lists(start_date, end_date, user_id){
        var that = this;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        var postData = {
            user_id: user_id,
            start_date: start_date+" 00:00:00",
            end_date: end_date+" 23:59:59",

        };
        if ($.fn.DataTable.isDataTable('#downloadQueueTable')) {
            $('#downloadQueueTable').DataTable().clear().destroy();
        }
        var downloadQueueTable = $('#downloadQueueTable').DataTable(
            {
                order:[],
                "processing": true,
                "serverSide": true,
                "bDestroy": true,
                "paging": true,
                "pageLength": 20,
                "bInfo" : false,
                "sPaginationType": "numbers",
                "searching": false,
                //"autoWidth": false,
                "responsive": false,
//                 "scrollX": true,
                "lengthMenu": [[20, 50, 100, 500 -1], [20, 50, 100, 500, "All"]],
                ajax: {
                    url:config.get('API_URL')+ "/users/report-download-queue",
                    type: "POST",
                    data: postData,
                    dataSrc:function ( json ) {

                        that.setState({
                            isChange: false
                        })
                        return json.data;
                    },
                    beforeSend: function(request) {
                        request.setRequestHeader("Authorization", localStorage.usertoken);
                    },
                    error: function (data) {

                    },
                    complete: function (data) {

                    },
                },

                columns: [
                    {"data":"email", "width":"100px"},
                    {"data":"report_name", "width":"100px"},
                    {"data":"start_date",},
                    {"data":"end_date"},
                    {"data":"request_timestamp"},
                    {"data":"status"},
                    {"data":"downloaded_file_path"},
                    {"data":"download_id"},
                ],
                "columnDefs": [
                    {  render: function (data) {
                            return "<div class='text-wrap width-150'>"+data+"</div>";
                        },
                        "width": "200px",
                        "targets": [1]
                    },
                    {  render: function (data) {
                            return "<div class=''>"+moment(data).format('D MMM YYYY')+"</div>";
                        },
                        "width": "200px",
                        "targets": [2,3]
                    },
                    {  render: function (data) {
                            return "<div class=''>"+moment(data).format('D MMM YYYY HH:mm:ss')+"</div>";
                        },
                        "width": "200px",
                        "targets": [4]
                    },
                    {
                        "width": "10px",
                        "targets": 5,
                        "data": "data",

                        "createdCell": (td, cellData, rowData, row, col) => {

                            var className = 'inactive-download-button';
                            var statusColumnClass = '';
                            if (rowData.status === 'Complete') {
                               className = '';
                               statusColumnClass = "doneLog";
                            } else if(rowData.status === 'InProgress') {
                                statusColumnClass = 'ongoingLog';
                            }
                            else if(rowData.status === 'Pending') {
                                statusColumnClass = 'failedLog';
                            }
                            else if(rowData.status === 'Invalidate' ||rowData.status === 'Failed') {
                                statusColumnClass='failedLog'
                            }

                            $(td).addClass(statusColumnClass);
                        },
                        bSortable: false,
                    },
                    {
                        "width": "10px",
                        "targets": 6,
                        "data": "data",

                        "createdCell": (td, cellData, rowData, row, col) => {
                            var className = 'inactive-download-button';

                            if (rowData.status === 'Complete') {
                               className = '';
                            }
                            $(td).text("");

                            $(td).append('<a href="#"  data-tip="Download Report" style="'+style+';" title="Download Report" class="'+className+'" >' +
                                        '<i class="fa fa-download" aria-hidden="true"></i>' +
                                    '</a>');
                            $(td).click(e => {
                                this.download_report(e,rowData["downloaded_file_path"], rowData["report_code"]);
                            })
                        },
                        bSortable: false,
                    },
                    {
                        "width": "10px",
                        "targets": 7,
                        "data": "data",
                        "createdCell": (td, cellData, rowData, row, col) => {

                            $(td).text("");

                            $(td).append('<a href="#"  data-tip="Download Report" style="'+style+';" title="Refresh" >' +
                                        '<i class="fa fa-refresh" aria-hidden="true"></i>' +
                                    '</a>');
                            $(td).click(e => {
                                this.get_all_lists(that.state.yestSend, that.state.todSend, that.state.user_id);
                            })
                        },
                        bSortable: false,
                    },

                ]
            });
//             $('#downloadQueueTable').on('click', 'td.action_button a', function (e) {
//             e.stopImmediatePropagation();
//             var file_path = $(this).data("row");
//                 console.log(file_path)
//                 that.download_report(file_path)
//             });
    }
    download_report(e, file_path, name){

        download_count = 0;
        file_path = JSON.parse(file_path);
        this.setState({
            model_visible : true,
            dw_msg: "Downloading",
            download_count: 1,
            total_count: file_path.length,
        })


        file_path.map((path, index) => {
            this.copyFile(path,name,index);
        });

    }
    copyFile (remotePath,name, index){
        //alert(remotePath); alert(name); alert(index)
        var postData = {
            remotePath: remotePath
        }

        let xhrBank = $.ajax({
            url:config.get('API_URL')+ "/reports/copy-file",
            type: "POST",
            data: postData,
            beforeSend: function (request) {
                request.setRequestHeader("Authorization", localStorage.usertoken);
            },
            xhrFields: {
                responseType: 'blob'
            },
            success: function (response, status, xhr) {
                let blob = new Blob([response], {
                    type: "octet/stream"
                });
                let fileName = new Date().getTime()+name+'.csv.gz';
                let rfile = fileName.replace(/\"/g, "");

                let a = document.createElement('a');
                let url = window.URL.createObjectURL(blob);
                a.href = url;
                a.download = rfile;
                a.click();
                window.URL.revokeObjectURL(url);
                download_count++;
                if(download_count===this.state.total_count){
                    this.setState({
                        dw_msg: "Downloaded"
                    })
                }
                this.setState({
                       download_count:download_count
                })

            }.bind(this)
        });
        this.setState({
            xhrBank: xhrBank
        })

    }
    closeModal() {
        this.setState({
            model_visible : false
        });
    }
    handleDateRange = (todSend, yestSend, datefromShow,dateToShow) =>
    {
        this.setState({
            todSend: todSend,
            yestSend: yestSend,
            datefromShow: datefromShow,
            dateToShow: dateToShow,
            isChange: true,
        }, ()=>{
            this.get_all_lists(yestSend, todSend, this.state.user_id);
        });

    }
    get_all_internal_users(){
        axios.post(config.get('API_URL')+'/tableau/get-all-internal-users/',
         {

         },
         {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },

        }).then(response => {

            if(Array.isArray(response.data) && response.data.length) {
                let mList = [];
                response.data.map((user, index) => {
                    mList.push({value: user.user_id, label: user.email})
                });
                this.setState({
                    user_list:mList,
                })
                var index = this.state.user_list.findIndex(obj => obj.value==this.state.user_id);
                this.state.user_list.move(index,0).join(',');
            }


        }).catch( err => {
            console.log(err);
        });
    }
    changeUser(optionSelected){
        let value='';
        let userArray = [];
        if(optionSelected.length < 1){
            value = null;
            userArray='';
        }
        else{
            optionSelected.map((uids, i) => {
                userArray.push(uids.value)
                var index = this.state.user_list.findIndex(obj => obj.value==uids.value);
                this.state.user_list.move(index,0).join(',');
            });
        }

        this.setState({
            user_id:userArray,
            userValue:optionSelected,
            isChange: true
        }, ()=>{
            this.get_all_lists(this.state.yestSend, this.state.todSend, userArray);
        });

    }
    render() {
        let queueTableData = this.state.download_queue_data.map((val,index) => {
            var className = 'inactive-download-button';
            var statusColumnClass = '';
            if (val.status === 'Complete') {
               className = '';
               statusColumnClass = 'doneLog';
            } else if(val.status === 'InProgress') {
                statusColumnClass = 'ongoingLog';
            }
            else if(val.status === 'Pending') {
                statusColumnClass = 'failedLog';
            }
            else if(val.status === 'Invalidate') {
                statusColumnClass='failedLog'
            }
            return (
                <tr key={index + 1}>
                    <td>{val["report_name"]}</td>
                    <td>{moment(val["start_date"]).format('D MMM YYYY HH:mm:ss')}</td>
                    <td>{moment(val["end_date"]).format('D MMM YYYY HH:mm:ss')}</td>
                    <td width="80px" align="center" className={statusColumnClass}>{val["status"]}</td>
                    <td className="text-center">
                        {/*<ReactTooltip className='actionTooltip' place="bottom" type="dark" effect="solid"/>*/}
                        <a href="#" onClick={this.download_report.bind(this, val.downloaded_file_path, val.report_code)} data-tip="Download" className={className} >
                            <i class="fa fa-download" aria-hidden="true"></i>
                        </a>
                        &nbsp;&nbsp;

                        <a href="#" onClick={this.get_all_lists.bind(this)} data-tip="Refresh" >
                            <i class="fa fa-refresh" aria-hidden="true"></i>
                        </a>
                    </td>

                </tr>
            )
        });

        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 pt-5">
                            <div className="card">
                                <div className="header">
                                    <h4 className="title">My Downloads</h4>
                                    {/*<p className="category"></p>*/}

                                </div>
                                <hr className="m-0"/>
                                <div className="content">
                                    <div className="row">
                                        <div className="col-md-3 filter-bottom5 padd-5 date-icon-small">
                                            <div><label> Date Filter: </label></div>
                                            <DateRangeFilter ref="daterangeFilter" onSelectDate = {this.handleDateRange} start_date = {this.state.datefrom} end_date={this.state.dateTo} display_start_date = {this.state.datefromShow} display_end_date = {this.state.dateToShow}
                                            start_date_limit = {this.state.dateFromLimit} end_date_limit = {this.state.dateLimit}/>
                                        </div>
                                        {this.state.userSubGroupName==='Admin'?
                                        <div className="col-md-3 filter-bottom5 padd-5">
                                            <label>Users</label>
                                            <ReactMultiSelectCheckboxes name="merchants"
                                                isMulti
                                                value={this.state.userValue}
                                                styles={reactSelectStyles} className="report-listbox"
                                                isClearable={false}
                                                onChange={this.changeUser.bind(this)}
                                                options={this.state.user_list}
                                                placeholderButtonLabel="Select [Users]"
                                            />

                                            <div className="clearfix"></div>
                                        </div>:null}
                                        <div class="col-md-4 pull-right">
                                            <br/>
                                            <span class="apply-notification">Refresh Page to see current status</span>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                    <div className="row">
                                    <div className="clearfix"></div>
                                        <div className="content-tdetails-table table-full-width table-responsive marginTop0">
                                            <table id="downloadQueueTable" className="table table-striped table-hover">
                                                <thead>
                                                    <tr>
                                                        <th width="100px">Email</th>
                                                        <th width="100px">Report Name</th>
                                                        <th>Start Date</th>
                                                        <th>End Date</th>
                                                        <th>Request timestamp</th>
                                                        <th>Status</th>
                                                        <th>Actions</th>
                                                        <th></th>
                                                    </tr>
                                                </thead>
                                                <tbody>

                                                </tbody>
                                            </table>
                                        </div>
                                        <ModalD visible={this.state.model_visible} width="300" height="100" effect="fadeInUp">
                                            <div className="download-popup-model">
                                                <div className="message-content">
                                                     <div>


                                                                <div>{this.state.dw_msg} {this.state.download_count}  of {this.state.total_count} reports</div>


                                                            <a href="javascript:void(0);" onClick={() => this.closeModal()}>
                                                                <i className="fa fa-times-circle" aria-hidden="true"></i>Close
                                                            </a>
                                                     </div>

                                                </div>
                                            </div>
                                        </ModalD>
                                    </div>
                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

const mapDispatchToProps = (dispatch) =>{
    return {
        currentMenu: (name)=>{dispatch({type:'change_menu',payload:name})}
    }
}
export default connect(null,mapDispatchToProps)(DownloadQueue);